import axios from "axios";
import { APP_URL } from "../../config/api";
import { errorMessage } from "../errorHandle";

export const uploadTrainingSyllabus = (cred) => {
  return (dispatch) => {
    dispatch({
      type: SYLLABUS.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/upload-training-syllabus`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: SYLLABUS.UPLOAD_TRAINING_SYLLABUS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, SYLLABUS.ERROR));
      });
  };
};

export const getTrainingSyllabus = (cred) => {
  return (dispatch) => {
    dispatch({
      type: SYLLABUS.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-training-syllabus`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: SYLLABUS.GET_TRAINING_SYLLABUS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, SYLLABUS.ERROR));
      });
  };
};

export const addTrainingSyllabus = (cred) => {
  return (dispatch) => {
    dispatch({
      type: SYLLABUS.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/add-training-syllabus`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: SYLLABUS.ADD_TRAINING_SYLLABUS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, SYLLABUS.ERROR));
      });
  };
};

export const deleteTrainingSyllabus = (cred) => {
  return (dispatch) => {
    dispatch({
      type: SYLLABUS.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/delete-training-syllabus`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: SYLLABUS.DELETE_TRAINING_SYLLABUS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, SYLLABUS.ERROR));
      });
  };
};

export const trainingAttendancesDetails = (cred) => {
  return (dispatch) => {
    dispatch({
      type: SYLLABUS.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/training-attendances-details`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: SYLLABUS.TRAINING_ATTENDANCE_DETAILS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, SYLLABUS.ERROR));
      });
  };
};

export const updateTrainingStatus = (cred) => {
  return (dispatch) => {
    // dispatch({
    //   type: SYLLABUS.REQUEST,
    // });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/update-training-start-status`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: SYLLABUS.UPDATE_TRAINING_STATUS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, SYLLABUS.ERROR));
      });
  };
};

export const setCurrentTopicId = (id) => {
  return (dispatch) => {
    dispatch({
      type: SYLLABUS.REQUEST,
    });

    dispatch({
      type: SYLLABUS.SET_CURRENT_TOPIC_ID,
      payload: id,
    });
  };
};

const TAG = "SYLLABUS_";

export const SYLLABUS = {
  ERROR: TAG + "ERROR",
  REQUEST: TAG + "REQUEST",
  UPLOAD_TRAINING_SYLLABUS: TAG + "UPLOAD_TRAINING_SYLLABUS",
  ADD_TRAINING_SYLLABUS: "ADD_TRAINING_SYLLABUS",
  GET_TRAINING_SYLLABUS: TAG + "GET_TRAINING_SYLLABUS",
  DELETE_TRAINING_SYLLABUS: TAG + "DELETE_TRAINING_SYLLABUS",
  TRAINING_ATTENDANCE_DETAILS: TAG + "TRAINING_ATTENDANCE_DETAILS",
  UPDATE_TRAINING_STATUS: TAG + "UPDATE_TRAINING_STATUS",
  SET_CURRENT_TOPIC_ID: TAG + "SET_CURRENT_TOPIC_ID",
};
